import heic2any from 'heic2any';

// Browsers other than Safari cannot decode HEIC, so anything uploaded as HEIC
// displays broken on the web. Some browsers (notably on Windows) also report an
// empty file.type for HEIC, so check the extension too.
export const isHeicFile = (file) => /heic|heif/i.test(file.type) || /\.(heic|heif)$/i.test(file.name);

// Converts a HEIC/HEIF File to a JPEG File with a matching .jpg extension.
export const convertHeicToJpeg = async (file) => {
  const blob = await heic2any({
    blob: file,
    toType: 'image/jpeg',
    quality: 0.94,
  });
  const name = `${file.name.replace(/\.(heic|heif)$/i, '')}.jpg`;
  return new File([blob], name, { type: 'image/jpeg', lastModified: Date.now() });
};
